import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.762 17.1765C14.3137 18.3208 12.579 18.9266 10.8275 18.9937C10.9403 18.5141 11 18.014 11 17.5C11 13.9101 8.08985 11 4.5 11C3.63546 11 2.81034 11.1688 2.05579 11.4752C1.77014 8.9875 2.58141 6.39778 4.48959 4.48959C7.80905 1.17014 13.191 1.17014 16.5104 4.48959C19.5907 7.56987 19.8126 12.4261 17.1763 15.7623L22.5206 21.1067L21.1064 22.5209L15.762 17.1765Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8.74261 14.6717L7.32839 13.2574L4.49996 16.0859L1.67154 13.2574L0.257324 14.6717L3.08575 17.5001L0.257324 20.3285L1.67154 21.7427L4.49996 18.9143L7.32839 21.7427L8.74261 20.3285L5.91418 17.5001L8.74261 14.6717Z"}}]};

const SearchErrorFilled = Vue.extend<IconProps>({
  name: 'SearchErrorFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'search-error-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default SearchErrorFilled;
